import type { MouseEventHandler } from "react";
import type { GallerySection } from "./types";
import { safeHref } from "./design";

export function PhotoGallery({ section, className, href, imageSrc = value => value, onNavigate }: {
  section: GallerySection; className: string; href(value?: string): string;
  imageSrc?(value: string): string; onNavigate?: MouseEventHandler<HTMLAnchorElement>;
}) {
  return <div className={className + (section.layout === "masonry" ? " gallery-masonry" : section.layout === "cards" ? " gallery-cards" : "")}>{section.images.map(image => {
    const photo = <img src={imageSrc(image.url)} alt={image.alt} loading={onNavigate ? undefined : "lazy"}/>;
    const content = section.showCaptions ? <figure>{photo}<figcaption>{image.alt}</figcaption></figure> : photo;
    const target = image.href ? safeHref(href(image.href)) : "";
    return target && target !== "#" ? <a className="gallery-link" key={image.id} href={target} onClick={onNavigate} {...(/^https?:/.test(target) ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{content}</a> : section.showCaptions ? <figure key={image.id}>{photo}<figcaption>{image.alt}</figcaption></figure> : <img key={image.id} src={imageSrc(image.url)} alt={image.alt} loading={onNavigate ? undefined : "lazy"}/>;
  })}</div>;
}
